module.exports = __webpack_public_path__ + "media/images/athletes/3562-2434860d3c50710d20a1771cc0087435.png";